import React, { useCallback } from 'react';
import { selectCanvasRect } from '~/dashboard/views/workflows/store/redux/selectors';
import { useAppSelector } from '~/store/reduxHooks';
import { StyledIslandDrawer, StyledIslandDrawerContent, StyledIslandItemContainer } from './styles';
import { COMPLEX_ISLAND_WIDTH, COMPLEX_ISLAND_DIFF_WIDTH } from '~/dashboard/views/workflows/service/graph';
import { useAnimationTrigger } from 'flow/editor/hooks';


interface BaseComplexIslandProps {
  children: React.ReactNode;
  onDrawerToggle: () => void;
  title: string;
  isInDiffMode?: boolean;
}

export default function BaseComplexIsland({
  children,
  onDrawerToggle,
  title,
  isInDiffMode,
}: BaseComplexIslandProps) {
  const { height: canvasHeight } = useAppSelector(selectCanvasRect);

  const [show, setShow] = useAnimationTrigger();

  /**
   * Passed as `size`, not just `defaultSize` — toggling diff mode on an
   * already-open island would leave the drawer at its previous width until reopened.
   */
  const islandWidth = isInDiffMode ? COMPLEX_ISLAND_DIFF_WIDTH : COMPLEX_ISLAND_WIDTH;

  const handleDrawerToggle = useCallback(() => {
    setShow(false);
    onDrawerToggle();
  }, [onDrawerToggle, setShow]);

  return (
    <StyledIslandDrawer
      canvasHeight={canvasHeight}
      placement="right"
      show={show}
      title={title}
      toggleDrawer={handleDrawerToggle}
      testIdForCloseBtn="closeIslandButton"
      size={islandWidth}
      defaultSize={islandWidth}
    >
      <StyledIslandDrawerContent>
        <StyledIslandItemContainer>
          {children}
        </StyledIslandItemContainer>
      </StyledIslandDrawerContent>
    </StyledIslandDrawer>
  );
}
